import PromoListFallback from 'components/Bcc/BccRwdPersonalizedPromoList/PromoListFallback/PromoListFallback';

export default PromoListFallback;
